import {
  CheckboxSelectionResult,
  useCheckboxSelection,
} from "@/hooks/useCheckboxSelection";
import type { CheckinStatus } from "@/types/reservation";
import type { CheckoutStatus } from "@/types/booking";
import { SettlementBooking } from "../types/settlementBooking";
import { useBulkUpdateReservations } from "@/hooks/useReservations";

export interface UseSettlementSelectedOptionsResult
  extends CheckboxSelectionResult {
  handleChangeStatus: (status: CheckinStatus | CheckoutStatus) => void;
  isBulkUpdating: boolean;
}

type SettlementStatusMode = "checkin" | "checkout";

export const useSettlementSelectedOptions = ({
  reservations,
  mode,
}: {
  reservations: SettlementBooking[];
  mode: SettlementStatusMode;
}): UseSettlementSelectedOptionsResult => {
  const selectionOptions = useCheckboxSelection({
    data: reservations,
    getId: (arr) => arr.id,
  });

  const bulkUpdateReservationsMutation = useBulkUpdateReservations();

  const handleChangeStatus = (status: CheckinStatus | CheckoutStatus) => {
    const selectedIds = selectionOptions?.selectedItems || [];
    if (selectedIds.length === 0) return;

    const payload = {
      ...(mode === "checkin"
        ? { checkinStatus: status as CheckinStatus }
        : { checkoutStatus: status as CheckoutStatus }),
      bookingIds: selectedIds,
    };

    bulkUpdateReservationsMutation.mutate(payload);
  };

  return {
    ...selectionOptions,
    handleChangeStatus,
    isBulkUpdating: bulkUpdateReservationsMutation.isPending,
  };
};
